import { EMAIL_REGEX, NO_2_CONSECUTIVE_DOTS_REGEX } from "./constants/constants.ts";

export function validateEmail(rule, value, callback) {
  if (value === "") {
    callback(new Error("Email is required"));
  }
  if (EMAIL_REGEX.test(value)) {
    if (NO_2_CONSECUTIVE_DOTS_REGEX.test(value)) {
      callback();
    } else {
      callback(
          new Error(
              "Please enter a valid email address"
          )
      );
    }
  } else {
    callback(new Error("Please enter a valid email address"));
  }
}
